import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import url from "@/utils/url";

class NewsHeader extends React.Component {
  render() {
    const { title, showSubTitle, subTitle, to, showMore, t } = this.props;
    return (
      <div className="flex-row news-section-head">
        <span className="section-title">{title}</span>
        {showSubTitle && <span className="section-sub-title">{subTitle}</span>}
        {showMore && (
          <span className="section-view-more block-when-pc">
            <RouterLink className="section-view-more-link" to={to}>
              {t("TWBC0001_more")}
              <img alt="" src={require("@/assets/images/arrow-right.svg")} />
            </RouterLink>
          </span>
        )}
      </div>
    );
  }
}

NewsHeader.propTypes = {
  title: PropTypes.string,
  showSubTitle: PropTypes.bool,
  subTitle: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  showMore: PropTypes.bool,
};

NewsHeader.defaultProps = {
  title: "News",
  showSubTitle: true,
  subTitle: "新着",
  to: url.news,
  showMore: true,
};

export default withTranslation()(NewsHeader);
